// extracted by mini-css-extract-plugin
module.exports = {"header":"DocHeadings_header__KjREf","anchor":"DocHeadings_anchor__8wav1"};